import { allSet } from "./allSet";
import { article } from "./article";
import { author } from "./author";
import { billingManagement } from "./billingManagement";
import { bio } from "./bio";
import { cancellationReason } from "./cancellationReason";
import { common } from "./common";
import { crew } from "./crew";
import { dashboard } from "./dashboard";
import { diagnosticDashboard } from "./diagnosticDashboard";
import { faqs } from "./faqs";
import { forgotPassword } from "./forgotPassword";
import { gathering } from "./gathering";
import { gatherings } from "./gatherings";
import { inviteAFriend } from "./inviteAFriend";
import { library } from "./library";
import { libraryCard } from "./libraryCard";
import { medicalReviewer } from "./medicalReviewer";
import { membershipPayment } from "./membershipPayment";
import { membershipSelect } from "./membershipSelect";
import { navigation } from "./navigation";
import { newsletterForm } from "./newsletterForm";
import { onboarding } from "./onboarding";
import { password } from "./password";
import { paymentConfirmation } from "./paymentConfirmation";
import { paymentIssue } from "./paymentIssue";
import { planManagement } from "./planManagement";
import { planPayment } from "./planPayment";
import { planSelect } from "./planSelect";
import { program } from "./program";
import { resetPassword } from "./resetPassword";
import { rsvp } from "./rsvp";
import { sanityResourceNotFound } from "./sanityResourceNotFound";
import { setPassword } from "./setPassword";
import { settings } from "./settings";
import { signIn } from "./signIn";
import { signUp } from "./signUp";
import { topic } from "./topic";
import { upsell } from "./upsell";

export const en = {
  allSet,
  article,
  author,
  billingManagement,
  bio,
  cancellationReason,
  common,
  crew,
  dashboard,
  diagnosticDashboard,
  faqs,
  forgotPassword,
  gathering,
  gatherings,
  inviteAFriend,
  library,
  libraryCard,
  membershipPayment,
  membershipSelect,
  medicalReviewer,
  navigation,
  newsletterForm,
  onboarding,
  paymentConfirmation,
  paymentIssue,
  password,
  planManagement,
  planPayment,
  planSelect,
  program,
  resetPassword,
  rsvp,
  sanityResourceNotFound,
  setPassword,
  settings,
  signIn,
  signUp,
  topic,
  upsell,
};
